import setLang from '../lang';

const lang = {
    i: {
        locale: 'vi-VN',
        select: {
            placeholder: 'Chọn',
            noMatch: 'Không tìm thấy',
            loading: 'Đang tải'
        },
        table: {
            noDataText: 'Không có dữ liệu',
            noFilteredDataText: 'Không có dữ liệu lọc',
            confirmFilter: 'Xác nhận',
            resetFilter: 'Làm lại',
            clearFilter: 'Xóa hết'
        },
        datepicker: {
            selectDate: 'Chọn ngày',
            selectTime: 'Chọn giờ',
            startTime: 'Ngày bắt đầu',
            endTime: 'Ngày kết thúc',
            clear: 'Xóa',
            ok: 'Đồng ý',
            datePanelLabel: '[Tháng mm]/[yyyy]',
            month: '',
            month1: 'Tháng 1',
            month2: 'Tháng 2',
            month3: 'Tháng 3',
            month4: 'Tháng 4',
            month5: 'Tháng 5',
            month6: 'Tháng 6',
            month7: 'Tháng 7',
            month8: 'Tháng 8',
            month9: 'Tháng 9',
            month10: 'Tháng 10',
            month11: 'Tháng 11',
            month12: 'Tháng 12',
            year: '',
            weekStartDay: '1',
            weeks: {
                sun: 'CN',
                mon: 'T2',
                tue: 'T3',
                wed: 'T4',
                thu: 'T5',
                fri: 'T6',
                sat: 'T7'
            },
            months: {
                m1: 'Th.1',
                m2: 'Th.2',
                m3: 'Th.3',
                m4: 'Th.4',
                m5: 'Th.5',
                m6: 'Th.6',
                m7: 'Th.7',
                m8: 'Th.8',
                m9: 'Th.9',
                m10: 'Th.10',
                m11: 'Th.11',
                m12: 'Th.12'
            }
        },
        transfer: {
            titles: {
                source: 'Nguồn',
                target: 'Đích'
            },
            filterPlaceholder: 'Nhập từ khóa',
            notFoundText: 'Không tìm thấy'
        },
        modal: {
            okText: 'Đồng ý',
            cancelText: 'Hủy bỏ'
        },
        poptip: {
            okText: 'Đồng ý',
            cancelText: 'Hủy bỏ'
        },
        page: {
            prev: 'Trang trước',
            next: 'Trang kế',
            total: 'Tổng',
            item: 'kết quả',
            items: 'kết quả',
            prev5: '5 trang trước',
            next5: '5 trang kế',
            page: '/trang',
            goto: 'Tới trang',
            p: ''
        },
        rate: {
            star: 'Sao',
            stars: 'Sao'
        },
        tree: {
            emptyText: 'Không có dữ liệu'
        }
    }
};

setLang(lang);

export default lang;


// WEBPACK FOOTER //
// ./src/locale/lang/vi-VN.js